import axios from "../utils/axios";

export class UploadService {
  uploadFile(file: File, purpose?: string, id?: string) {
    const formData = new FormData();
    formData.append("file", file);
    if (purpose) {
      formData.append("purpose", purpose);
    }
    if (id) {
      formData.append("id", id);
    }
    return axios.post("/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
